import Component from '@bythepixel/component-loader';

const cssClasses = {
  buttonVisible: 'section-sub-nav-product-details__button--visible',
  subNavVisible: 'section-sub-nav-product-details--visible',
};

export default class SectionSubNavProductDetails extends Component {
  static selector = '[data-comp-section-sub-nav-product-details]';

  constructor(el) {
    super(el);
    this.contactButton = this.$container.querySelector('[data-sub-nav-button]');
    this.form = document.querySelector('[data-comp-lead-form]');
    this.mediaGallery = document.querySelector('[data-comp-media-gallery]');
    this.observeMediaGallery();
  }

  observeMediaGallery() {
    if (!this.mediaGallery) {
      return;
    }

    const watchMediaGallery = entries => {
      const entry = entries[0];

      if (entry.intersectionRatio === 0 && !this.$container.classList.contains(cssClasses.subNavVisible)) {
        this.$container.classList.add(cssClasses.subNavVisible);
        this.contactButton.classList.add(cssClasses.buttonVisible);
      } else {
        this.$container.classList.remove(cssClasses.subNavVisible);
        this.contactButton.classList.remove(cssClasses.buttonVisible);
      }
    };

    const observer = new IntersectionObserver(watchMediaGallery);
    observer.observe(this.mediaGallery);
  }
}
